import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, CanLoad } from '@angular/router';

import { SessionService } from '../session/session.service';

@Injectable()
export class VersionGuard implements CanActivate, CanActivateChild, CanLoad {
  constructor(private session: SessionService) {}

  public canActivate(): boolean {
    return !(
      this.session.isComingFromApp() &&
      this.session.minimumAppVersion.isGreaterThen(
        this.session.currentAppVersion
      )
    );
  }

  public canActivateChild(): boolean {
    return this.canActivate();
  }

  public canLoad(): boolean {
    return this.canActivate();
  }
}
